import StrategyOverviewPage from './container'
/**
 * @module StrategyOverviewPage
 * @description 投資策略
 */
export default StrategyOverviewPage;